"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTypes = createTypes;
exports.asyncAction = asyncAction;
function createTypes(prefix) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return args.reduce(function (types, type) {
    [].concat(type).map(function (v) {
      return types[v] = prefix + v;
    });
    return types;
  }, {});
}
function asyncAction(type) {
  var subTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["REQUEST", "SUCCESS", "FAIL"];
  return [].concat(subTypes.map(function (t) {
    return type + "_" + t;
  }));
}